/** @format */

import { Box } from '@mui/material';
import { DocumentsViewDto } from '../../../Models';

interface Props {
  document: DocumentsViewDto;
}
export default function ViewImage({ document }: Props) {
  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <img
        src={document.link}
        alt={document.documentTypeName}
        style={{ height: '100%', width: '100%' }}
      />
    </Box>
  );
}
